import React, { useState, useEffect, useRef } from 'react';
import './AboutUsSection.css';

const AboutUsSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    const currentSection = sectionRef.current;

    if (currentSection) {
      observer.observe(currentSection);
    }

    return () => {
      if (currentSection) {
        observer.unobserve(currentSection);
      }
    };
  }, []);

  const title = "ABOUT US";

  return (
    <section className="about-section" ref={sectionRef}>
      <h2 className={`about-title ${isVisible ? 'visible' : ''}`}>
        {title.split('').map((char, idx) => (
          <span
            key={idx}
            className="title-letter"
            style={{ animationDelay: `${idx * 0.08}s` }}
          >
            {char === ' ' ? '\u00A0' : char}
          </span>
        ))}
      </h2>
      
      <div className="about-content">
        <div className={`about-image ${isVisible ? 'visible' : ''}`}>
          <img 
            src={require('../images/about-nft.webp')} 
            alt="NFT Example" 
            className="nft-example"
          />
        </div>
        
        <div className={`about-text ${isVisible ? 'visible' : ''}`}>
          <p>
            Welcome to the Alliance! A collective of 777 Angry Aliens ready to assimilate the Hedera Network! Hand-drawn and layered using random generation! Created by the developer of $Monsta, the successfully bonded entertainment character token on HBAR! 
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutUsSection;